import { render, staticRenderFns } from "./FlagPicker.vue?vue&type=template&id=3896d972&"
import script from "./FlagPicker.vue?vue&type=script&lang=js&"
export * from "./FlagPicker.vue?vue&type=script&lang=js&"
import style0 from "./FlagPicker.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports